import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import * as entryPasses from './entry-passes';
import * as leases from './leases';
import * as companies from './companies';
import * as officers from './officers';
import * as notifications from './notifications';

const reducer = combineReducers({
	entryPasses: entryPasses.reducer,
	leases: leases.reducer,
	companies: companies.reducer,
	officers: officers.reducer,
	notifications: notifications.reducer,
});

const epic = combineEpics(entryPasses.epic, leases.epic, companies.epic, officers.epic, notifications.epic);

export { reducer, epic };
